/** Topics this browser already stamped (cosmetic: the server enforces one stamp per visitor). */
const KEY = "sikilesi:damgalanan";

function read(storage: Storage): Set<string> {
  try {
    const raw = storage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as unknown) : [];
    return new Set(Array.isArray(list) ? list.filter((x): x is string => typeof x === "string") : []);
  } catch {
    return new Set();
  }
}

export function isStamped(id: string, storage: Storage = localStorage): boolean {
  return read(storage).has(id);
}

export function markStamped(id: string, storage: Storage = localStorage): void {
  try {
    const set = read(storage);
    set.add(id);
    storage.setItem(KEY, JSON.stringify([...set].slice(-500)));
  } catch {
    // storage unavailable (private mode): fine
  }
}
